import axios from 'axios';

const KLAVIYO_API_URL = 'https://a.klaviyo.com/client';

const client = axios.create({
  baseURL: KLAVIYO_API_URL,
  params: { company_id: 'RGiBuy' },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    revision: '2024-02-15',
  },
});

export async function registerEmailInKlaviyo(email, language) {
  const data = {
    data: {
      type: 'profile',
      attributes: {
        email: email,
      },
      properties: {
        preferred_language: language,
      },
    }
  };

  try {
    const response = await client.post('/profiles', data);
    console.log('Email registered successfully:', response);
  } catch (error) {
    console.error('Error registering email:', error);
  }
}

export const KlaviyoAPI = {
  token: 'RGiBuy',

  /**
   * Subscribes a profile to a list, by email
   *
   * @param {string} email customer email
   * @param {string} listId klaviyo list id
   * @returns {Promise<object>}
   */
  async subscribeToList(email, listId) {
    const data = {
      data: {
        type: 'subscription',
        relationships: { list: { data: { type: 'list', id: listId } } },
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
              },
            },
          },
        },
      }
    };
    const response = await client
      .post(`/subscriptions`, data)
      .then((r) => r)
    return response;
  },

  /**
   *
   * @param {string} email - email of the subscriber
   * @param {number} variantId - variant id to subscribe to
   */
  async subscribeToBackInStock(email, variantId) {
    try {
      const data = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId,
              },
            },
          },
        }
      };

      const response = await client.post(
        '/back-in-stock-subscriptions',
        data
      );

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
